import template from './employee_upload_document.html';
import * as Permissions from '../../lib/permission_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeCreateDocumentUploadViewModel
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.photofile = ko.observable();
		this.leave_type_id = ko.observable();
		this.allowed_values = ko.observableArray([ko.observable('')]);
		this.ll_cycle_date = ko.observable();
		this.available_leave_types = ko.observableArray();

		this.doc_types = ko.observableArray();
		this.doc_type = ko.observable();

		this.new_name = ko.observable('');
		this.file_name = ko.observable('');
		this.note = ko.observable('');
	
		this.selected_type_id = ko.observable();
		this.access_roles = ko.observableArray();

		this.default_viewing_role = ko.observableArray();
		this.view_access_rights = ko.observable(false); 
		this.is_only_employee_role = ko.observable(true);
		this.is_only_unverified_role = ko.observable(false);
		this.has_file = ko.observable(false);

		this.is_expired = ko.observable(false);
		this.valid_date = ko.observable('');

		this.file_name.subscribe((newText) => {
			let filename = newText;

			filename = filename.replace('C:\\fakepath\\', '');
			filename = filename.substr(0, filename.lastIndexOf('.')) || filename;
		
			if (this.new_name() == '' || this.new_name() == null)
				this.new_name(filename);
		});

		this.selected_type_id.subscribe((newID) => {
			this.dialog.update_type(newID);
		});
	};

	close()
	{
		this.dialog.close();
	}

	async save_document()
	{
		// UPLOAD FILE
		let formData = new FormData($('#batchuploadform')[0]);
		if (document.getElementById('upload-emp-doc').files[0])
		{
			if (document.getElementById('upload-emp-doc').files[0].size > 20000000)
			{
				Grape.alerts.alert({type: 'error', message: tr('File size exceeds the maximum limit of 20MB', 'File size exceeds the maximum limit of 20MB'), title: tr('Error', 'Error')});
				formData.append('abort_upload', 'true');
				return;
			}
		}

		if (this.default_viewing_role() == undefined || this.default_viewing_role() == '' || this.default_viewing_role() == null)
			formData.append('abort_upload', 'true'); // abort the upload on the API side

		//this.file_name($('#upload-emp-doc').val());
		formData.append('employee_id', this.dialog.bindings.employee_id);
		formData.append('doc_type', this.selected_type_id());
		formData.append('viewing_roles', this.default_viewing_role());

		formData.append('name', document.getElementById('txtDescription_dialog').value);
		formData.append('note', document.getElementById('txtNote_dialog').value);
		formData.append('file', this.file_name());
		formData.append('valid_date', this.valid_date());

		let xhr = new XMLHttpRequest();

		if ($('#upload-emp-doc').val() == '')
			Grape.alerts.alert({ type: 'error', message: tr('File not selected'), title: tr('Error', 'Error') });
		else
		{
			xhr.open('post', '/employee/upload_document', true);
			xhr.setRequestHeader('Accept', 'application/json');
			xhr.send(formData);

			xhr.onreadystatechange = async () => {
				if (xhr.readyState === 4)
				{
					let res = JSON.parse(xhr.response);

					if (res.status == 'ERROR')
						Grape.alerts.alert({ type: 'error', message: res.message, title: tr('Error', 'Error') });
					else if (res.status == 'OK')
					{
						let message = tr('Successfully saved document.');

						if ( !(await Permissions.checkAccessRights('EmployeeDocumentAdministration')))
							message = tr('Document has been uploaded and submitted for approval. Once approved the approval status of the document will update.');

						await Grape.alerts.alert({type: 'success', message: tr(message, message), title: tr('Success', 'Success')});
						$('#upload-emp-doc').val('');
						this.dialog.updateData();
						this.dialog.close();
					}
					else
						Grape.alerts.alert({ type: 'error', message: 'something went wrong', title: tr('Error', 'Error') });
				}
			};
		}
	};
};

class EmployeeCreateDocumentUploadPage
{
	constructor(bindings)
	{
		this.viewModel = new EmployeeCreateDocumentUploadViewModel(this);
		this.bindings = bindings;
		this.viewModel.default_viewing_role.push('admin');

		$('input[id=batch_file]').change(() => {
			$('#upload-emp-doc').val($(this).val().replace('C:\\fakepath\\', ''));
		});
	};

	async updateData()
	{
		//autocomplete(document.getElementById('txtDescription_dialog'), window.global_AutoComplete_Dictionary_Documents);
		//autocomplete(document.getElementById('txtNote_dialog'), window.global_AutoComplete_Dictionary_Documents);

		let doc_types = await Grape.cache.get('EmployeeDocumentTypeLookup') || [];

		// Filter out Payslip and UIF document types
		doc_types = doc_types.filter(type => 
			type.type !== 'Payslip' && 
			type.type !== 'UIF'
		);

		if (doc_types && doc_types.length > 0)
		{
			doc_types = doc_types.sort((a, b) => {
				let a_type = a?.type || '';
				let b_type = b?.type || '';
				if (a_type === 'HR')
					return -1;
				if (b_type === 'HR')
					return 1;

				return a_type.localeCompare(b_type); // Sort other items alphabetically
			});
			
			this.viewModel.doc_types(doc_types);
			if (doc_types[0])
				this.viewModel.selected_type_id(doc_types[0].general_document_type_id);
		}

		if (this.bindings.employee_document_type_id != null)
			this.viewModel.selected_type_id(this.bindings.employee_document_type_id); // auto select the type we specified in bindings

		if (this.bindings.valid_date != null)
			this.viewModel.valid_date(this.bindings.valid_date);

		try {
			let options = {
				table: 'access_role',
				schema: 'grape',
				limit: 1000000,
				sortfield: 'role_name',
				sortorder: 'ASC',
				filter: [{ 
					value: ['guest', 'admin', 'manager', 'employee', 'accountant', 'general_manager', 'all', 'developer', 'director', 'unverifed_user'],
					operand: 'IN',
					field: 'role_name'
				}]
			};

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status != 'ERROR')
				this.viewModel.access_roles(res.records);
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: tr('Could not load access roles...')});
		}
	};

	async init()
	{
		if (Permissions.isLoggedInUser_Unverified() == true)
			this.viewModel.is_only_unverified_role(true);
		else
			this.viewModel.is_only_employee_role(Permissions.isLoggedInUser_OnlyEmployee());
	
		this.viewModel.view_access_rights(await Permissions.checkAccessRights('EmployeeDocumentAdministration'));
		this.updateData();
	};

	async update_type(type_id)
	{
		try
		{
			if (!type_id)
			{
				this.viewModel.default_viewing_role.removeAll();
				//add employee role if needed
				if (this.viewModel.is_only_employee_role() === true)
					this.viewModel.default_viewing_role.push('employee');
				return;
			}

			let options = {
				table: 'employee_document_types',
				schema: 'public',
				limit: 1,
				sortfield: 'type',
				sortorder: 'asc',
				filter: [{ value: parseInt(type_id), operand: '=', field: 'employee_document_type_id' }]
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status !== 'ERROR')
			{
				console.log("the result ", res.records);
				if (res)
					this.viewModel.default_viewing_role(res.records[0].default_viewing_roles);
				else
					this.viewModel.default_viewing_role.removeAll();

				// when an employee is uploading a document - we force tick the employee field in the default viewing roles ( so that they can see their own document once uploaded )
				if (this.viewModel.is_only_employee_role() == true && this.viewModel.default_viewing_role.indexOf('employee') == -1)
					this.viewModel.default_viewing_role.push('employee');		
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: tr('Could not load document types...')});
		}
	}
};

export default {
	name: 'EmployeeUploadDocument',
	dialog_class: EmployeeCreateDocumentUploadPage,
	template: template,
	template_filename: 'translation/dialogs/employee_upload_document',
	provider: 'ps'
};
